import { FC } from 'react';

interface IGlyphIcon {
  className?: string;
  color?: string;
  onClick?: () => void;
}

const Mastercard: FC<IGlyphIcon> = ({ className = '', onClick }) => {
  return (
    <svg
      width="58"
      height="40"
      viewBox="0 0 58 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      className={className}
    >
      <rect x="0.5" y="0.5" width="57" height="39" rx="5.5" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.6316 28.0491C26.6582 29.7125 24.0984 30.7166 21.3011 30.7166C15.0597 30.7166 10 25.7171 10 19.55C10 13.3828 15.0597 8.3833 21.3011 8.3833C24.0984 8.3833 26.6582 9.38746 28.6316 11.0509C30.605 9.38746 33.1649 8.3833 35.9621 8.3833C42.2036 8.3833 47.2632 13.3828 47.2632 19.55C47.2632 25.7171 42.2036 30.7166 35.9621 30.7166C33.1649 30.7166 30.605 29.7125 28.6316 28.0491Z"
        fill="#ED0006"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.6316 28.0491C31.0615 26.0009 32.6023 22.9532 32.6023 19.55C32.6023 16.1467 31.0615 13.099 28.6316 11.0509C30.605 9.38746 33.1649 8.3833 35.9621 8.3833C42.2035 8.3833 47.2632 13.3828 47.2632 19.55C47.2632 25.7171 42.2035 30.7166 35.9621 30.7166C33.1649 30.7166 30.605 29.7125 28.6316 28.0491Z"
        fill="#F9A000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.6316 28.0492C31.0615 26.001 32.6023 22.9533 32.6023 19.5501C32.6023 16.1469 31.0615 13.0992 28.6316 11.051C26.2018 13.0992 24.661 16.1469 24.661 19.5501C24.661 22.9533 26.2018 26.001 28.6316 28.0492Z"
        fill="#FF5E00"
      />
      <rect x="0.5" y="0.5" width="57" height="39" rx="5.5" stroke="#E0E6EB" />
    </svg>
  );
};

export default Mastercard;
